import { gql } from '@apollo/client'

export default gql`
  fragment MeetingTargetsCalculationHelper on Meeting {
    targetsCalculationHelper {
      pastTargetsReferenceYear
      newTargetsReferenceYear
    }
  }
`
